/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require("./bootstrap");
require("./components");
import { Html5Qrcode } from "html5-qrcode";
import html2canvas from 'html2canvas';

// window.Vue = require('vue').default;

// import { createApp } from 'vue';
// let app=createApp({})
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// app.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });

// app.mount("#app")

// window.Vue = require('vue').default;
// Vue.createApp(app).mount('#app')
// window.events = new Vue();

import 'boxicons';
window.html2canvas = html2canvas;
window.Html5Qrcode = Html5Qrcode;
